/**
 * @file A simple component to display a loading spinner or message.
 */
import React from 'react';

const Loader = () => {
    return <p>Cargando...</p>;
};

export default Loader;
